module.exports = ".list-view {\n  height: 500px;\n  overflow: scroll; }\n"